import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import 'MagnificPopup';
import 'slick';
import { memberPortal } from "../member-portal";
import * as moment from 'moment'

export class submissionStatusClaimLCP {
	
	initStatusDetails(): any {
		$("#submission-status-li").on("click", function(){
			getAirlinesStatus();
			getNonAirlinesStatus();
		});
	}

}

function getAirlinesStatus() {
	$("#claim-submission-status").addClass("disable_html");
	if(location.host == "localhost:5000"){
		$.ajax({
			type: 'GET',
			url: 'http://localhost:5000/dummy-data/submissionStatus.JSON',
			contentType: 'application/json',
			success: function (data: any) {
				$("#claim-submission-status").removeClass("disable_html");
				createAirlineStatusTable(data);
				$("#DataTables_Table_MalOtherAirlines_length").hide()
				// createPagination(currentPageNumber, data.numberOfPages);
			},
			error: function (error: any) {
			}
		});

	}else{ 
		$.ajax({
			type: 'GET',
			url: '/bin/services/new/getClaimSubmissionStatus',
			// data: data_obj,
			contentType: 'application/json',
			success: function (data: any) {
				$("#claim-submission-status").removeClass("disable_html");
				createAirlineStatusTable(data);
				$("#DataTables_Table_MalOtherAirlines_length").hide();
				// createPagination(currentPageNumber, data.numberOfPages);
			},
			error: function (error: any) {
			}
		});

	}
	
}

function getNonAirlinesStatus() {
	if(location.host == "localhost:5000"){
		$.ajax({
			type: 'GET',
			url: 'http://localhost:5000/dummy-data/submissionStatusNA.JSON',
			contentType: 'application/json',
			success: function (data: any) {
				createNonAirlineStatusTable(data);
				$("#DataTables_Table_NonAirlines_length").hide();
				// createPagination(currentPageNumber, data.numberOfPages);
			},
			error: function (error: any) {
			}
		});

	}else{
		// var data_obj = "pageOffset=" + currentPageNumber;
		$.ajax({
			type: 'GET',
			url: '/bin/services/new/getNonAirlineClaimStatus',
			// data: data_obj,
			contentType: 'application/json',
			success: function (data: any) {
				createNonAirlineStatusTable(data);
				$("#DataTables_Table_NonAirlines_length").hide();
				// createPagination(currentPageNumber, data.numberOfPages);
			},
			error: function (error: any) {
			}
		});

	}
	
}

function createAirlineStatusTable(jsonDataArray: any) {

		let benefitsTable = $('#DataTables_Table_MalOtherAirlines');
		jsonDataArray = jsonDataArray.map(data => {data.flightDate = moment(data.flightDate, 'DD-MM-YYYY').format('YYYY-MM-DD'); return data})
		benefitsTable.dataTable().fnClearTable();
		benefitsTable.dataTable().fnDestroy();
		let dataSet = jsonDataArray;
		let tableOptions = {
			data: dataSet,
			"columns": [
				{ "data": "flightDate", "render" : formatDates },
				{ "data": "flightNumber"},
				{ "data": "origin" },
				{ "data": "destination" },
				{ "data": "ticketNumber" },
				{ "data": "flightClass" },
				{ "data": "status" }
			]
			
		  }
		
		let benefitsDataTable:any = benefitsTable.dataTable(tableOptions);
		
}

function createNonAirlineStatusTable(jsonDataArray: any) {

		let benefitsTable = $('#DataTables_Table_NonAirlines');
		jsonDataArray = jsonDataArray.map(data => {data.transactionDate = moment(data.transactionDate, 'DD-MM-YYYY').format('YYYY-MM-DD'); return data})
		benefitsTable.dataTable().fnClearTable();
		benefitsTable.dataTable().fnDestroy(); 
		let dataSet = jsonDataArray;
		let tableOptions = {
			data: dataSet,
			"columns": [
				{ "data": "transactionDate","render" : formatDates },
				{ "data": "enrichPartner" },
				{ "data": "proofOfActivity" },
				{ "data": "location" },
				{ "data": "status" }
			],
			"columnDefs": [
			  { "width": "350px", "targets": 2 }
			]
		  }
		
		let benefitsDataTable:any = benefitsTable.dataTable(tableOptions);
		
}
function formatDates(data:any,type:any,row:any){
	if(type === "sort" || type === "type"){
		return data;
	}
	return moment(data, 'YYYY-MM-DD').format('DD-MM-YYYY');

}
let scope:Element = document.querySelector('#claim-submission-status');
if (scope) {
	try {
	let submissionStatusClaim = new submissionStatusClaimLCP();
	submissionStatusClaim.initStatusDetails();
	} catch(e) {console.error(e);}
}
